import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Alert,
  Box,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

function MissionsGroupPanel({ date, mission }) {
  const tasks = Array.isArray(mission?.tasks) ? mission.tasks : [];
  const hasMission = !!mission?.id;

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        Group FE for missions comes from <strong>day-config</strong>, not per-task FE. The old
        mission <code>fan_energy_reward</code> is legacy for the standalone Daily Missions card.
      </Alert>

      {!hasMission ? (
        <Alert severity="warning" sx={{ mb: 2 }} icon={false}>
          <Chip label="No missions scheduled" color="warning" size="small" sx={{ mr: 1 }} />
          Empty missions group is allowed — the app only requires non-empty groups for day complete.
        </Alert>
      ) : null}

      <Box display="flex" gap={1} mb={2} flexWrap="wrap">
        {hasMission ? (
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            component={Link}
            to={`/admin/daily-missions/${mission.id}`}
            endIcon={<OpenInNewIcon fontSize="small" />}
          >
            Edit mission pack
          </Button>
        ) : (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            component={Link}
            to={`/admin/daily-missions/new?date=${date}`}
            endIcon={<OpenInNewIcon fontSize="small" />}
          >
            Create mission pack for {date}
          </Button>
        )}
        <Button
          variant="text"
          component={Link}
          to="/admin/daily-missions?from=today"
          endIcon={<OpenInNewIcon fontSize="small" />}
        >
          Open Daily Missions list
        </Button>
      </Box>

      {hasMission && (
        <>
          <Typography variant="subtitle2" gutterBottom>
            {mission.title || 'Daily Mission'} · {tasks.length} task{tasks.length === 1 ? '' : 's'}
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Target</TableCell>
                <TableCell>Navigation</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography color="text.secondary">No tasks on this pack.</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                tasks.map((task, idx) => (
                  <TableRow key={task.task_key || task.id || idx}>
                    <TableCell>{task.title || '—'}</TableCell>
                    <TableCell>
                      <code>{task.action_key || '—'}</code>
                    </TableCell>
                    <TableCell>{task.target_value ?? '—'}</TableCell>
                    <TableCell>
                      <Typography variant="caption" noWrap sx={{ maxWidth: 220, display: 'block' }}>
                        {task.navigation_link || '—'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </>
      )}
    </Box>
  );
}

export default MissionsGroupPanel;
